<template>
    <div class="info-container">
        <head-bar title="商品详情" :border="true" :fixed="true">
            <div slot="right" class="head-right">
                <div
                    class="home-icon icon-style"
                    @click="$router.push('/')"
                ></div>
                <div
                    class="search-icon icon-style"
                    @click="$router.push('/product/search')"
                ></div>
            </div>
        </head-bar>
        <div class="product-swiper">
            <van-swipe :autoplay="3000" indicator-color="#4bc227">
                <van-swipe-item
                    v-for="(item, index) in productInfo.imgList"
                    :key="index"
                >
                    <img
                        class="swiper-item-cover"
                        :src="$config.QINIU_URL + item.filePath"
                    />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="product-info">
            <div class="product-name">
                <template v-if="Array.isArray(productInfo.labelList)">
                    <span
                        class="lable-item"
                        :key="index"
                        :style="{
                            backgroundColor: item.backgroundColor,
                            color: item.fontColor,
                        }"
                        v-for="(item, index) in productInfo.labelList"
                        >{{ item.labelName }}</span
                    >
                </template>
                <span>{{ productInfo.goodsName }}</span>
            </div>
            <ul class="info-ul">
                <li class="info-item">
                    <span class="info-name">原厂编码</span>
                    <span class="info-params">{{
                        productInfo.factoryCode
                    }}</span>
                </li>
                <li class="info-item" v-if="productInfo.brand.brandName">
                    <span class="info-name">品牌</span>
                    <span class="info-params">{{
                        productInfo.brand.brandName
                    }}</span>
                </li>
                <li class="info-item" v-if="hasBatch">
                    <span class="info-name">批次</span>
                    <span class="info-params">{{
                        productInfo.stock.batchList[0].batchNo
                    }}</span>
                </li>
                <li class="info-item" v-if="!hasRelation">
                    <span
                        class="info-name encode-text"
                        @click="() => openRelationWindow(productInfo)"
                        >自定义物料编码</span
                    >
                </li>
                <li
                    class="info-item"
                    v-if="hasRelation"
                    @click="deleteRelation"
                >
                    <span class="info-name">自定义编码</span>
                    <span class="info-params">{{
                        productInfo.relation.customCode
                    }}</span>
                    <span class="params_delete_icon"></span>
                </li>
                <li class="info-item">
                    <span class="info-name">库存</span>
                    <span class="info-params"
                        >{{ productInfo.stock.qtyTotal }}&nbsp;pcs</span
                    >
                </li>
                <li class="info-item">
                    <span class="info-name">包装</span>
                    <span class="info-params"
                        >每{{ productInfo.packingUnitOuter }}&nbsp;{{
                            productInfo.packingQty
                        }}&nbsp;pcs</span
                    >
                </li>
                <li class="info-item">
                    <span class="info-name">起购数</span>
                    <span class="info-params"
                        >&nbsp;{{ productInfo.minPurchase }}&nbsp;pcs</span
                    >
                </li>
            </ul>
        </div>
        <div class="product-price">
            <div class="caption">
                <span>含税单价({{ $config.TAX_NUMBER }}%)</span>
            </div>
            <ul class="info-ul">
                <li
                    class="info-item"
                    v-for="(item, index) in productInfo.priceRangeList"
                    :key="index"
                >
                    <span class="info-name">{{ item.qtyStart }}+</span>
                    <span
                        class="info-params"
                        :class="{
                            'last-price':
                                index == productInfo.priceRangeList.length - 1,
                        }"
                        >￥{{ item.price }}</span
                    >
                </li>
            </ul>
        </div>
        <div class="product-params">
            <div class="caption">
                <span>参数</span>
            </div>
            <ul class="info-ul">
                <li class="info-item">
                    <span class="info-name">毛重</span>
                    <span class="info-params">{{
                        productInfo.roughWeight
                    }}</span>
                </li>
                <li
                    class="info-item"
                    v-for="(item, index) in productInfo.stdlibList"
                    :key="index"
                >
                    <span class="info-name">{{ item.libName }}</span>
                    <span class="info-params">{{
                        item.libattrItemList[0].itemValue
                    }}</span>
                </li>
            </ul>
        </div>
        <div class="settlement-bar">
            <div class="bar-item go-cart" @click="$router.push('/cart')">
                <span>购物车</span>
            </div>
            <div class="bar-item"></div>
            <div
                class="bar-item join-cart"
                @click="openBuyWindow(productInfo)"
                :class="{ disabled: unableBuy }"
            >
                <span>购买此商品</span>
            </div>
        </div>
        <!-- 购买窗口 -->
        <buy-window @buy="confirmPurchase"></buy-window>
        <!-- 购买窗口 -->
        <!-- 自定义物料窗口 -->
        <BackFill @confirm="confrimRelation"></BackFill>
        <!-- 自定义物料窗口 -->
    </div>
</template>

<script>
const default_product_info = {
    brand: {
        brandName: "",
    },
    stock: {
        qtyTotal: 0,
    },
};
import {
    cart_join,
    cart_buy,
    cart_create,
    cart_update,
} from "@/helper/types/cart";
import { isLogin, getBasket } from "@/utils/auth";
import Vue from "vue";
import { Swipe, SwipeItem, Toast, Dialog } from "vant";
import HeadBar from "@/components/HeadBar.vue";
import BuyWindow from "./children/BuyWindow";
import { findComponentDownward } from "@/utils/findComponents";
import { addProductRelation, deleteProductRelation } from "@/utils/product";
import BackFill from "./children/encode/Backfill";
import { isEmpty } from "@/utils/validation";
Vue.use(Swipe)
    .use(SwipeItem)
    .use(Toast);
export default {
    name: "ProductInfo",
    components: {
        HeadBar,
        BuyWindow,
        BackFill,
    },
    data() {
        return {
            productInfo: default_product_info,
        };
    },
    beforeMount() {
        let productId = this.$route.query.id;
        this.getCurrentProductInfo(productId);
    },
    methods: {
        /**
         * @description 获取商品详情
         */
        getCurrentProductInfo(productId) {
            if (isEmpty(productId)) {
                this.$router.push({
                    path: "/",
                });
                return;
            }
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let _this = this;
            let productInfoURL = this.$api.productApi.getProductInfo;
            this.$axios
                .post(productInfoURL, {
                    context: {
                        productId,
                    },
                })
                .then((response) => {
                    let productInfo = response.data || {};
                    _this.productInfo = productInfo;
                    // _this.shareProduct(productInfo);
                })
                .catch(() => {
                    _this.$router.push({
                        path: "/",
                    });
                })
                .finally(() => {
                    _this.$toast.clear();
                });
        },
        /**
         * @description 打开购买窗口
         */
        openBuyWindow(productInfo) {
            if (this.unableBuy) return;
            let _this = this;
            let { productId, quantity = 0 } = productInfo;
            let buyWindowComponent = findComponentDownward(this, "BuyWindow");
            _this.cartHasProduct({
                productId: productId,
                success: (productInfo) => {
                    Dialog.confirm({
                        title: "购物车提示",
                        message: `您的购物车内已有此商品${quantity}pcs,确定要替换掉购物车内数量吗?`,
                        confirmButtonColor: "#4BC227",
                    })
                        .then(() => {
                            _this.getProductInfo(productId, (data) => {
                                buyWindowComponent.open(data, cart_update);
                            });
                        })
                        .catch(() => {});
                },
                failed: () => {
                    _this.getProductInfo(productId, (data) => {
                        buyWindowComponent.open(data, cart_create);
                    });
                },
            });
        },
        /**
         * @description 获取商品详情
         */
        getProductInfo(productId, cb) {
            this.$axios
                .post(this.$api.productApi.getProductInfo, {
                    context: {
                        productId,
                    },
                })
                .then((response) => {
                    let productInfo = response.data || {};
                    cb && cb(productInfo);
                });
        },
        /**
         * @description 确认购买
         */
        confirmPurchase(info) {
            let _this = this;
            let { eventType, pcs, productId, cartOperation } = info;
            _this.cartOperation({
                type: cartOperation,
                productId: productId,
                pcs: pcs,
                success: (data) => {
                    let msg =
                        cartOperation == cart_create
                            ? "加入购物车成功"
                            : "购物车数量更新成功";
                    if (eventType == cart_join) {
                        _this.$toast.success({
                            message: msg,
                            duration: 2000,
                        });
                    } else {
                        _this.$router.push("/cart");
                    }
                },
            });
        },
        /**
         * @description 购物车操作
         */
        cartOperation(info) {
            if (!info.type) return;
            let { type, pcs, productId, success } = info;
            let cartOperationURL = this.$api.cartApi.cart_operationApi;
            this.$axios
                .post(cartOperationURL, {
                    operation: type,
                    context: {
                        quantity: pcs,
                        productId: productId,
                        basketId: isLogin() ? "" : getBasket(),
                    },
                })
                .then((response) => {
                    let data = response.data || {};
                    success && success(data);
                });
        },
        /**
         * @description 检测购物车是否包含此商品
         */
        cartHasProduct(info) {
            if (isEmpty(info)) return;
            let { productId, success, failed } = info;
            let operationURL = this.$api.cartApi.cart_operationApi;
            this.$axios
                .post(operationURL, {
                    operation: "retrieve",
                    context: {
                        productId: productId,
                    },
                })
                .then((response) => {
                    let data = response.data || {};
                    success && success(data);
                })
                .catch(() => {
                    failed && failed();
                });
        },
        /**
         *  @description 打开物料窗口
         */
        openRelationWindow(productInfo) {
            if (!isLogin()) {
                this.$router.push({
                    path: "/account/login/password",
                });
                return;
            }
            let backFillWindow = findComponentDownward(this, "BackFill");
            backFillWindow.open(productInfo);
        },
        /**
         *  @description 确认关联
         */
        confrimRelation(encodeInfo) {
            let _this = this;
            let encodeOperationURL = this.$api.userApi.encodeOperation;
            let { goodsCode, productId, customCode } = encodeInfo;
            let request = {
                context: {
                    goodsCode,
                    customCode,
                    productId,
                },
                operation: "create",
            };
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(encodeOperationURL, request)
                .then((response) => {
                    let backFillWindow = findComponentDownward(
                        _this,
                        "BackFill"
                    );
                    backFillWindow.close();
                    _this.$nextTick(() => {
                        let productList = addProductRelation(
                            [_this.productInfo],
                            productId,
                            customCode
                        );

                        _this.productInfo = productList[0];
                    });
                })
                .catch(() => {})
                .finally(() => {
                    _this.$toast.clear();
                });
        },
        /**
         * @description 删除自定义编码关联
         */
        deleteRelation() {
            let _this = this;
            let encodeOperationURL = this.$api.userApi.encodeOperation;
            Dialog.confirm({
                title: "提示",
                message: `确定删除自定义物料编码吗?`,
                confirmButtonColor: "#4BC227",
            })
                .then(() => {
                    let { goodsCode, productId } = _this.productInfo;
                    let request = {
                        context: {
                            goodsCode,
                        },
                        operation: "delete",
                    };
                    _this.$toast.loading({
                        message: "数据加载中...",
                        duration: 0,
                    });
                    _this.$axios
                        .post(encodeOperationURL, request)
                        .then((response) => {
                            let productList = deleteProductRelation(
                                [_this.productInfo],
                                productId
                            );
                            _this.productInfo = Object.assign({
                                ...productList[0],
                            });
                        })
                        .catch(() => {})
                        .finally(() => {
                            _this.$toast.clear();
                        });
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
    computed: {
        /**
         * @description 计算是否不能购买
         */
        unableBuy() {
            let { stock, minPurchase = 0 } = this.productInfo;
            return stock.qtyTotal < minPurchase;
        },
        //是否有批次
        hasBatch() {
            let { batchList = [] } = this.productInfo.stock;
            return !isEmpty(batchList);
        },
        //是否包含自定义编码
        hasRelation() {
            let { relation = {} } = this.productInfo;
            return !isEmpty(relation.customCode);
        },
    },
};
</script>
<style lang="less" scoped>
.head-right {
    position: relative;
    z-index: 10;
    height: 90px;
    > .icon-style {
        position: absolute;
        z-index: 50;
        top: 50%;
        margin-top: -24px;
        width: 48px;
        height: 48px;
        background-size: 48px;
        background-repeat: no-repeat;
        background-position: center;
    }
    .home-icon {
        right: 30px;
        background-image: url("../../public/images/cart/go-home-icon.png");
    }
    .search-icon {
        right: 140px;
        background-image: url("../../public/images/cart/go-search-icon.png");
    }
}
.info-container {
    width: 100%;
    padding-top: 90px;
    padding-bottom: 101px;
    .product-swiper {
        padding: 10px 0;
        width: 100%;
        height: 300px;
        background-color: #fff;
        .swiper-item-cover {
            display: block;
            margin: 0 auto;
            height: 300px;
        }
    }
    .product-info {
        margin-top: 10px;
        padding: 30px;
        background-color: #fff;
        .product-name {
            font-size: 32px;
            font-weight: 400;
            line-height: 40px;
            color: #333;
            text-align: left;
            word-break: break-all;
            .lable-item {
                margin-right: 5px;
                *display: inline;
                display: inline-block;
                zoom: 1;
                height: 40px;
                padding: 0 15px;
                font-size: 24px;
                line-height: 40px;
            }
        }
        > .info-ul {
            margin-top: 30px;
            font-size: 0px;
            > .info-item {
                text-align: left;
                margin-bottom: 10px;
                .info-name {
                    vertical-align: top;
                    *display: inline;
                    display: inline-block;
                    zoom: 1;
                    min-width: 120px;
                    padding-right: 40px;
                    font-size: 28px;
                    line-height: 40px;
                    color: #999;
                    &.encode-text {
                        color: #4bc227;
                    }
                }
                .info-params {
                    vertical-align: top;
                    *display: inline;
                    display: inline-block;
                    zoom: 1;
                    font-size: 28px;
                    line-height: 40px;
                    color: #333;
                }

                .params_delete_icon {
                    *display: inline;
                    display: inline-block;
                    vertical-align: -30px;
                    margin-left: 10px;
                    zoom: 1;
                    height: 22px;
                    width: 22px;
                    background-image: url("../../public/images/product/relation_delete_icon.png");
                    background-size: 22px;
                }
            }
        }
    }
    > .product-price {
        margin-top: 10px;
        padding: 30px;
        background-color: #fff;
        .caption {
            font-size: 32px;
            color: #333;
        }
        .info-ul {
            margin-top: 30px;
            font-size: 0px;
            > .info-item {
                text-align: left;
                margin-bottom: 10px;
                .info-name {
                    vertical-align: top;
                    *display: inline;
                    display: inline-block;
                    zoom: 1;
                    min-width: 150px;
                    padding-right: 40px;
                    font-size: 28px;
                    line-height: 40px;
                    color: #999;
                }
                .info-params {
                    vertical-align: top;
                    *display: inline;
                    display: inline-block;
                    zoom: 1;
                    font-size: 28px;
                    line-height: 40px;
                    color: #666;
                    &.last-price {
                        color: #f50;
                    }
                }
            }
        }
    }
    > .product-params {
        padding: 30px;
        margin-top: 10px;
        background-color: #fff;
        .caption {
            font-size: 32px;
            color: #333;
        }
        > .info-ul {
            margin-top: 30px;
            font-size: 0px;
            > .info-item {
                text-align: left;
                margin-bottom: 10px;
                .info-name {
                    vertical-align: top;
                    *display: inline;
                    display: inline-block;
                    zoom: 1;
                    min-width: 150px;
                    padding-right: 40px;
                    font-size: 28px;
                    line-height: 40px;
                    color: #999;
                }
                .info-params {
                    vertical-align: top;
                    *display: inline;
                    display: inline-block;
                    zoom: 1;
                    font-size: 28px;
                    line-height: 40px;
                    color: #333;
                }
            }
        }
    }
}
.settlement-bar {
    position: fixed;
    z-index: 10;
    left: 50%;
    margin-left: -375px;
    bottom: 0;
    width: 750px;
    height: 100px;
    background-color: #fff;
    .bar-item {
        float: left;
        width: 33.3%;
        height: 100px;
        line-height: 100px;
        &.now-buy-btn {
            height: 100px;
            background-color: #e0fed7;
            font-size: 32px;
            text-align: center;
            color: @theme-color;
        }
        &.go-cart {
            font-size: 28px;
            text-align: right;
            background-image: url("../../public/images/cart/go-cart-icon.png");
            background-repeat: no-repeat;
            background-position: 50px 22px;
            span {
                padding-right: 60px;
                color: #666;
            }
        }
        &.join-cart {
            font-size: 32px;
            background-color: @theme-color;
            text-align: center;
            color: #fff;
        }
        &.disabled {
            background-color: #ccc;
        }
    }
}
</style>
